import {GET, POST, PUT} from './networkFetch';

import {
  ADD_BANK_DETAILS,
  ADD_BANK_NEW,
  ADD_LIQUIDITY,
  ADD_PAYMENT,
  BANK_DETAILS,
  BUY_ORDER,
  CANCEL_BUY_ORDER,
  CANCEL_SELL_ORDER,
  CLOSED_MARKET,
  CLOSED_MARKET_HEADER,
  CREATE_ORDER_WEB,
  DELETE_ACC,
  EVENT_DETAIL,
  FAQs,
  GET_ADD_LIQUIDITY_SHARES,
  GET_CONFIG,
  GET_EXIT_POSITION,
  GET_INSTANT_PRICE,
  GET_INSTANT_UPDATED_PRICE,
  GET_LIVE_PROBES,
  GET_MERGE_SHARES_AMOUNT,
  GET_PROBES,
  GET_REFERRAL_DATA,
  GET_TRUE_PRICE,
  FETCH_ORDER_JUSPAY,
  GET_UPDATED_PRICE,
  GET_USER,
  GET_WALLET_TRANSACTIONS,
  LAST_TXN_STATUS,
  SEND_OTP,
  MERGE_SHARES,
  REDEEM_REQUEST,
  REMOVE_LIQUIDITY,
  REMOVE_LIQUIDITY_SHARES,
  SELL_ORDER,
  TRADING_FEE,
  VERIFY_COUPON_RECHARGE,
  UPDATE_USER_DETAILS,
  USER_PROFILE,
  VERIFY_MOBILE,
  VERIFY_OTP,
  VERIFY_COUPON,
  VERIFY_GOOGLE_TOKEN,
  PLACE_CLUB_ORDER,
  GET_CLUB_EVENT_DETAIL,
  GET_CLUB_EVENT_UPDATED_ODDS,
  CLUBS_CLOSED,
  FETCH_CLUB_MARKETS,
  CLUBS_LIVE,
  CLUB_SETTLE,
  CLUB_CREATE,
  FETCH_CLUB_DETAILS,
  TDS_BREAKUP,
  SEND_OTP_EMAIL,
  VERIFY_OTP_EMAIL,
  GET_BLOCKED_PINCODE,
  BANNERS,
  EVENT_REFERRAL,
  GET_EXCHANGE_RATE,
  VALIDATE_WALLET,
  CRYPTO_REDEEM_REQUEST,
  FETCH_ONMETA_ORDER_STATUS,
  FETCH_PRO_TRADER_DETAILS,
  GET_LIVE_PROBES_CONTEST,
  CONTEST_CLOSED,
  CONTEST_LIVE,
  CONTEST_DETAIL,
  ENTER_CONTEST,
  CONTEST_TOP_UP,
  CONTEST_BALANCE,
  CONTEST_EVENTS,
  CONTEST_LEADERBOARD,
  EVENT_DETAIL_CONTEST,
  CONTEST_CHAT,
  CONTEST_CLOSED_DETAIL,
  USER_PARTNER_PROFILE,
  GET_WP_SESSION,
  GET_WP_STATUS,
  WP_LOGIN_APPROVE,
  TEST_API,
  ADD_MOBILE,
  SMILE_COINS_DETAIL,
  LUCKY_COINS_REDEEM,
  LUCKY_COINS_REDEEM_CRYPTO,
  LUCKY_COINS_CONFIRM_REDEEM_CRYPTO,
  GET_COUPON_LIST,
  VERIFY_OTP_EMAIL_LOGIN,
  SEND_OTP_EMAIL_LOGIN,
  CLAIM_REWARD,
  GET_REWARD_DETAIL,
  CREATE_TOKEN_EVENT,
  GET_REWARDS_HISTORY,
  GET_TOKEN_DETAILS,
  GET_MM,
  SET_PRICE_RANGE,
  MERGE_SHARES_CDA,
  POWER_TRADE_SHARES,
  POWER_TRADE,
} from './apiUrl';
import {globalConst} from './globalConstant';

export const Network = {
  getConfig: ({headers = {}} = {}) => {
    let updatedHeaders = headers;
    if (localStorage.getItem('isOauthRedirect')) {
      const selectedCountry = localStorage.getItem('selectedCountry');
      updatedHeaders = {
        ...headers,
        ...(selectedCountry && { country: selectedCountry })
      };
    }
    return GET(
      `${GET_CONFIG}?app_version=${globalConst.appVersion}&isAllLang=true`,
      { headers: updatedHeaders },
      false,
    );
  },
  getProbes: data => POST(GET_PROBES, data),
  getEventDetail: data => POST(EVENT_DETAIL, data),
  getContestEventDetail: data => POST(EVENT_DETAIL_CONTEST, data),
  tradingFee: data =>
    GET(
      `${TRADING_FEE}?noofcontracts=${data.shares}&price=${data.price}&max_returns=100.00&eventid=${data.eventid}`,
      data,
    ),
  buyOrder: (data, isShowLoader) =>
    POST(BUY_ORDER, data, null, isShowLoader, true),
  getTruePrice: data =>
    GET(
      `${GET_TRUE_PRICE}?eventId=${data.eventId}&action=${data.action}&callvalue=${data.callvalue}&price=${data.amount}&noofcontracts=${data.shares}`,
      null,
      true,
    ),
  getUpdatedPrice: data =>
    GET(
      `${GET_UPDATED_PRICE}?eventId=${data.eventId}&action=${data.action}&callvalue=${data.callvalue}&price=${data.amount}&noofcontracts=${data.shares}`,
      null,
      true,
    ),
  getAddLiquidityShares: data =>
    POST(GET_ADD_LIQUIDITY_SHARES, data, null, false, true),
  addLiquidity: (data, isShowLoader) =>
    POST(ADD_LIQUIDITY, data, null, isShowLoader, true),
  getFaqs: () => GET(`${FAQs}`),
  getWalletTransactions: data => POST(GET_WALLET_TRANSACTIONS, data),
  getLastTxnStatus: () => GET(`${LAST_TXN_STATUS}`),
  addNewBank: (data, isShowLoader) =>
    POST(ADD_BANK_NEW, data, null, isShowLoader),
  verifyMobile: data => POST(VERIFY_MOBILE, data),
  sendOTP: (data, isShowLoader) => POST(SEND_OTP, data, null, isShowLoader),
  verifyCouponCode: data => POST(VERIFY_COUPON, data),
  verifyOTP: (data, isShowLoader) => POST(VERIFY_OTP, data, null, isShowLoader),
  sendOTPEmail: (data, isShowLoader) =>
    POST(SEND_OTP_EMAIL_LOGIN, data, null, isShowLoader),
  verifyOTPEmail: (data, isShowLoader) =>
    POST(VERIFY_OTP_EMAIL_LOGIN, data, null, isShowLoader),
  getBankDetails: data => GET(BANK_DETAILS, data),
  getUserProfile: data => POST(USER_PROFILE, data),
  getUser: data => GET(GET_USER, data),
  getReferralData: data => GET(`${GET_REFERRAL_DATA}`),
  updateUserDetails: (data, config) => POST(UPDATE_USER_DETAILS, data, config),
  deleteAcc: (data, isShowLoader) => POST(DELETE_ACC, data, null, isShowLoader),
  redeemRequest: (data, isShowLoader) =>
    POST(REDEEM_REQUEST, data, null, isShowLoader),
  cryptoRedeemRequest: (data, isShowLoader) =>
    POST(CRYPTO_REDEEM_REQUEST, data, null, isShowLoader),
  addBankDetails: data => POST(ADD_BANK_DETAILS, data, null, true),
  createOrderWeb: (data, config, isShowLoader) =>
    POST(CREATE_ORDER_WEB, data, config, isShowLoader),
  getClosedMarket: data => POST(CLOSED_MARKET, data),
  closeMarketHeader: () => GET(`${CLOSED_MARKET_HEADER}`),
  getLivePortfolio: (data, tokenHeader) =>
    POST(GET_LIVE_PROBES, data, tokenHeader),
  getLivePortfolioContest: (data, tokenHeader) =>
    POST(GET_LIVE_PROBES_CONTEST, data, tokenHeader),
  cancelBuyOrder: (data, isShowLoader) =>
    POST(CANCEL_BUY_ORDER, data, null, isShowLoader, true),
  cancelSellOrder: (data, isShowLoader) =>
    POST(CANCEL_SELL_ORDER, data, null, isShowLoader, true),
  getAmountMergeShare: data =>
    POST(GET_MERGE_SHARES_AMOUNT, data, null, false, true),
  mergeShare: (data, isShowLoader) =>
    POST(MERGE_SHARES, data, null, isShowLoader, true),
  mergeShareCda: (data, isShowLoader) =>
    POST(MERGE_SHARES_CDA, data, null, isShowLoader, true),
  getExiPosition: data => POST(GET_EXIT_POSITION, data, null, false, true),
  getInstantUpdatedPrice: ({
    eventId,
    action,
    callvalue,
    noofcontracts,
    range,
  }) =>
    GET(
      GET_INSTANT_UPDATED_PRICE.replace('{eventId}', eventId)
        .replace('{action}', action)
        .replace('{callValue}', callvalue)
        .replace('{contracts}', noofcontracts)
        .replace('{range}', range),
      null,
      true,
    ),
  getInstantPrice: ({eventId, action, callvalue, noofcontracts}) =>
    GET(
      GET_INSTANT_PRICE.replace('{eventId}', eventId)
        .replace('{action}', action)
        .replace('{callValue}', callvalue)
        .replace('{contracts}', noofcontracts),
      null,
      true,
    ),
  sendOTPVerifyEmail: data => POST(SEND_OTP_EMAIL, data),
  verifyEmailOtp: data => POST(VERIFY_OTP_EMAIL, data),
  sellOrder: (data, isShowLoader) =>
    POST(SELL_ORDER, data, null, isShowLoader, true),
  getRemoveLiquidityShares: data =>
    POST(REMOVE_LIQUIDITY_SHARES, data, null, false, true),
  RemoveLiquidity: (data, isShowLoader) =>
    POST(REMOVE_LIQUIDITY, data, null, isShowLoader, true),
  getPowerTradeShares: data =>
      POST(POWER_TRADE_SHARES, data, null, false, true),
  PowerTrade: (data, isShowLoader) =>
      POST(POWER_TRADE, data, null, isShowLoader, true),
  verifyGoogleEmail: (data, isShowLoader) =>
    POST(VERIFY_GOOGLE_TOKEN, data, null, isShowLoader),
  addPayment: (data, isShowLoader) =>
    POST(ADD_PAYMENT, data, null, isShowLoader),
  verifyCouponCodeRecharge: (data, isShowLoader) =>
    POST(VERIFY_COUPON_RECHARGE, data, null, isShowLoader),
  getExchangeRate: (data, isShowLoader) =>
    POST(GET_EXCHANGE_RATE, data, null, isShowLoader),
  verifyWalletAddress: (data, isShowLoader) =>
    POST(VALIDATE_WALLET, data, null, isShowLoader),
  fetchJuspay: (data, isShowLoader) =>
    POST(FETCH_ORDER_JUSPAY, data, null, isShowLoader),

  //clubs
  fetchClubDetails: id => GET(`${FETCH_CLUB_DETAILS}/${id}`),
  placeClubBet: ({eventId, clubId}, data, isShowLoader) =>
    POST(
      PLACE_CLUB_ORDER.replace('{eventId}', eventId).replace(
        '{clubId}',
        clubId,
      ),
      data,
      null,
      isShowLoader,
    ),
  getClubEventDetails: ({eventId, clubId}) =>
    GET(
      GET_CLUB_EVENT_DETAIL.replace('{eventId}', eventId).replace(
        '{clubId}',
        clubId,
      ),
    ),
  getUpdatedClubOdds: ({eventId, clubId}, data) =>
    POST(
      GET_CLUB_EVENT_UPDATED_ODDS.replace('{eventId}', eventId).replace(
        '{clubId}',
        clubId,
      ),
      data,
      null,
    ),
  getClubs: data => GET(`${CLUBS_CLOSED}`),
  fetchClubMarkets: id => GET(`${FETCH_CLUB_MARKETS}/${id}/markets`),
  fetchClubLive: id => GET(`${CLUBS_LIVE}/${id}/live`),
  fetchClubClosed: id => GET(`${CLUBS_CLOSED}/${id}/closed`),

  joinClub: (id, isShowLoader) =>
    POST(`${FETCH_CLUB_MARKETS}/${id}/join`, {}, null, isShowLoader),

  settleClub: (data, isShowLoader) =>
    PUT(CLUB_SETTLE, data, null, isShowLoader),
  createClub: ({clubId}, data, isShowLoader) =>
    POST(CLUB_CREATE.replace('{clubId}', clubId), data, null, isShowLoader),
  tdsBreakUp: (data, isShowLoader) =>
    POST(TDS_BREAKUP, data, null, isShowLoader),
  getBlockedPincode: data => POST(GET_BLOCKED_PINCODE, data),
  getBanners: screen => GET(`${BANNERS}?page=${screen}`),
  getContestClose: screen =>
    GET(`${CONTEST_CLOSED}?limit=1000&page=0&format=1,2`),
  getContestLive: id => GET(`${CONTEST_LIVE}`),
  referEvent: (data, config) => POST(EVENT_REFERRAL, data, config, false),
  enterContest: (data, isShowLoader) =>
    POST(ENTER_CONTEST, data, null, isShowLoader),
  fetchOnMetaOrderStatus: (data, isShowLoader) =>
    POST(FETCH_ONMETA_ORDER_STATUS, data, null, isShowLoader),
  fetchProTraderData: (data, isShowLoader) => GET(FETCH_PRO_TRADER_DETAILS),
  getWPSession: (data, isShowLoader) =>
    GET(GET_WP_SESSION, {}, null, isShowLoader),
  getWPStatus: (data, isShowLoader) =>
    GET(GET_WP_STATUS.replace('{sessionId}', data)),
  approveWPLogin: (data, isShowLoader) =>
    POST(WP_LOGIN_APPROVE, data, null, isShowLoader),
  getSmileCoinsDetails: contestId => GET(`${SMILE_COINS_DETAIL}`),
  addMobile: (data, isShowLoader) => POST(ADD_MOBILE, data, null, isShowLoader),

  // contest
  getSelectedContestDetails: contestId =>
    GET(CONTEST_DETAIL.replace('{contestId}', contestId)),
  contestTopUp: (data, isShowLoader) =>
    POST(CONTEST_TOP_UP, data, null, isShowLoader),
  contestEvents: (data, isShowLoader) =>
    POST(CONTEST_EVENTS, data, null, isShowLoader),
  getContestBalance: (contestId, isShowLoader) =>
    GET(`${CONTEST_BALANCE}${contestId}`),
  contestGetChat: (data, isShowLoader) =>
    POST(CONTEST_CHAT, data, null, isShowLoader),
  getContestLeaderBoardDetails: contestId =>
    GET(CONTEST_LEADERBOARD.replace('{contestId}', contestId)),
  getContestClosedDetails: contestId =>
    GET(CONTEST_CLOSED_DETAIL.replace('{contestId}', contestId)),
  // partner login
  getUserPartnerProfile: (data, isShowLoader) =>
    POST(USER_PARTNER_PROFILE, data, null, isShowLoader),

  getBankList: url => GET(TEST_API + url),
  redeemSmileCoins: (data, isShowLoader) =>
    POST(LUCKY_COINS_REDEEM, data, null, isShowLoader),
  redeemCryptoSmileCoins: (data, isShowLoader) =>
    POST(LUCKY_COINS_REDEEM_CRYPTO, data, null, isShowLoader),
  redeemCryptoConfirmSmileCoins: (data, isShowLoader) =>
    POST(LUCKY_COINS_CONFIRM_REDEEM_CRYPTO, data, null, isShowLoader),
  getCouponList: (data, isShowLoader) =>
    GET(GET_COUPON_LIST, data, null, isShowLoader),
  claimReward: (data, isShowLoader) =>
    POST(CLAIM_REWARD, data, null, isShowLoader),
  getRewardDetail: (data, isShowLoader) => GET(GET_REWARD_DETAIL),
  createTokenEvent: (data, isShowLoader) =>
    POST(CREATE_TOKEN_EVENT, data, null, isShowLoader),
  getRewardHistory: (data, isShowLoader) => GET(GET_REWARDS_HISTORY),
  getTokenSummary: (data, isShowLoader) => GET(GET_TOKEN_DETAILS),
  getMarketMaking: (data, isShowLoader) => GET(GET_MM),
  setPriceRange: (data, isShowLoader) =>
    POST(SET_PRICE_RANGE, data, null, isShowLoader),
  mmCancelAll: (data, isShowLoader) => 
    POST(`${TEST_API}probe/mmCancelAll`, data, null, isShowLoader, true),
};
